import { useEffect, useState, useMemo } from "react";
import "../../../scss/backoffice.scss";
import { Sidemenu } from "../Sidemenu";
import { Topbar } from "../Topbar";
import { Footer } from "../Footers";
import { protectedResources } from "../../../authConfig";
import ErrorList from "../../../components/backend/ErrorList";
import {
  Container,
  Row,
  Col,
  Button,
  Table,
  Alert,
  Spinner,
  Card,
  Modal,
} from "react-bootstrap";
import { FileUploader } from "react-drag-drop-files";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import moment from "moment-timezone";
const FileSaver = require("file-saver");
import { FaCloudUploadAlt, FaFileDownload } from "react-icons/fa";
import { BiSolidMessageAltError } from "react-icons/bi";

const API_BASE_URL =
  protectedResources.apiHRMobile.baseApi + "/api/v1/UniformSurveyBackend";

interface UploadLog {
  uploadedBy: string;
  uploadDateTime: string;
  fileName?: string;
  recordCount: number;
  fileContent: any;
  status: string;
  errorMessage?: ErrorLog[];
  bytes?: string;
}

interface ErrorLog {
  row: string | number;
  message: string;
  category: string;
}



interface ErrorCategory {
  [key: string]: ErrorItem[];
}

interface ErrorListProps {
  errors: ErrorCategory;
}

interface ErrorItem {
  row: number;
  message: string;
}

export const UniformUploadBenefit: React.FC = () => {
  const [pageLoder, setPageLoder] = useState(false);
  const [file, setFile] = useState<File | null>(null);
  const [fileName, setFileName] = useState<string>("");
  const [loading, setLoading] = useState<{ upload: boolean; export: boolean }>({
    upload: false,
    export: false,
  });
  const [uploadLogs, setUploadLogs] = useState<UploadLog[]>([]);
  const [processing, setProcessing] = useState<boolean>(false);
  const [errors, setErrors] = useState<ErrorLog[]>([]);

const [showModal, setShowModal] = useState(false);
const [selectedErrorLog, setSelectedErrorLog] = useState<ErrorCategory | null>(null);

  const token = useMemo(() => {
    const tokenData = sessionStorage.getItem("AccessToken");
    return tokenData ? JSON.parse(tokenData).value : "";
  }, []);

  useEffect(() => {
    fetchUploadLogs();
  }, []);

  const fetchUploadLogs = async (): Promise<void> => {
    setPageLoder(true);
    try {
      const response = await axios.get<UploadLog[]>(
        `${API_BASE_URL}/GetAllUniformBenefitUploadLogs`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setUploadLogs(response.data);
    } catch (error) {
      toast.error("Failed to fetch upload logs.");
    } finally {
      setPageLoder(false);
    }
  };

  const handleFileChange = (file: File): void => {
    setFile(null);
    setErrors([]);
    setTimeout(() => {
      setFile(file);
      setFileName(file.name);
    }, 0);
  };

  const handleUpload = async (): Promise<void> => {
    if (!file) {
      toast.error("Please select a file first.");
      return;
    }

    setLoading((prev) => ({ ...prev, upload: true }));
    setProcessing(true);
    setErrors([]);

    const formData = new FormData();
    formData.append("file", file);

    try {
      await axios.post(`${API_BASE_URL}/UploadExcelUniformBenefit`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
      toast.success("File processed successfully!");
      setFile(null);
      setFileName("");
      fetchUploadLogs();
    } catch (error: any) {
      fetchUploadLogs();
      setErrors(error.response.data || "Upload failed.");
      toast.error("!Found  incorrect condition in  Excel file");
    } finally {
      setLoading((prev) => ({ ...prev, upload: false }));
      setProcessing(false);
      setFileName("");
    }
  };

  const handleDownloadFromBytes = (fileName: string, fileData: string) => {
    try {
      const byteCharacters = atob(fileData);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      FileSaver.saveAs(blob, fileName);
      toast.success("File downloaded successfully!");
    } catch (error) {
      toast.error("Failed to process file download.");
    }
  };

  const downloadExcel = async () => {
    setLoading((prev) => ({ ...prev, export: true }));

    try {
      const response = await axios.get(
        `${API_BASE_URL}/ExportUniformBenefitsToExcel`,
        {
          responseType: "blob",
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const timestamp = moment().format("YYYYMMDD_HHmmss");
      const fileName = `UniformBenefits_${timestamp}.xlsx`;

      FileSaver.saveAs(
        new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        }),
        fileName
      );

      toast.success("Excel file downloaded successfully!");
    } catch (error) {
      toast.error("Failed to download file.");
    } finally {
      setLoading((prev) => ({ ...prev, export: false }));
    }
  };

  const latestUpload = uploadLogs
    .filter((log) => log.status === 'Success' ) 
    .reduce<UploadLog | null>((latest, log) => {
      if (
        !latest ||
        new Date(log.uploadDateTime) > new Date(latest.uploadDateTime)
      ) {
        return log;
      }
      return latest;
    }, null);

  const latestUploadDate = latestUpload
    ? moment(latestUpload.uploadDateTime).tz("Asia/Bangkok").format("DD-MM-YYYY HH:mm:ss")
    : " loading..";
  
    
    const transformErrors = (errors: any): ErrorCategory => {
      return errors.errors;
    };
    
    const handleShowErrors = (errorLog: unknown) => {
      if (typeof errorLog === "string") {  
        try {
          const obj = JSON.parse(errorLog);
          setSelectedErrorLog(obj as ErrorCategory); 
          setShowModal(true);
        } catch (error) {
          // Invalid JSON format
        }
      } else {
        // Expected a string but received a non-string value
      }
    };
    

    const handleCloseModal = () => {
      setShowModal(false);
      setSelectedErrorLog(null);
    };
    
  //console.log("errorsArray=", errors);
  return (
    <div className="container-fluid master-layout">
      <Sidemenu />
      <div className="main-container">
        <Topbar />
        <Container fluid className="mt-4">
          <Row className="mb-3 align-items-center">
            <Col md={12}>
              <h1 className="page-title">Uniform Upload Benefit</h1>
            </Col>
          </Row>

          <Card className="p-4 shadow-sm">
            <Row>
              <Col md={9}>
                <div className="upload-benefit my-3">
                  <FileUploader
                    className="custom-fileUploader"
                    handleChange={handleFileChange}
                    name="file"
                    key={fileName}
                    types={["xlsx"]}
                  />
                  {fileName && (
                    <Button
                      onClick={handleUpload}
                      disabled={loading.upload}
                      className="btn-submit ms-3 btn-upload-benefit-file"
                    >
                      Upload Excel{" "}
                      {loading.upload ? (
                        <Spinner
                          animation="border"
                          size="sm"
                          className="me-2"
                        />
                      ) : null}
                    </Button>
                  )}

                  {fileName && (
                    <p className="mt-4 text-primary">
                      <strong>Selected File</strong> : {fileName}
                    </p>
                  )}
                </div>
              </Col>
              <Col md={3} className="text-end my-3">
                <div className="btn-event">
                  <Button
                    onClick={downloadExcel}
                    disabled={loading.export}
                    className="btn-import ms-3"
                    style={{ height: "49px" }}
                  >
                    <img src="../../../images/backoffice/external-link.png" />{" "}
                    Download Master{" "}
                    {loading.export ? (
                      <Spinner animation="border" size="sm" className="me-2" />
                    ) : null}
                  </Button>
                </div>
                <p
                  className="text-muted mt-2 p-0 mb-0"
                  style={{ fontSize: "12px" }}
                >
                  <strong> Last Update: </strong>{" "}
                  <span className="blinking-text">{latestUploadDate}</span>
                </p>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                {processing && (
                  <Alert
                    variant="success"
                    className="mt-3 blinking-text-header"
                  >
                    Processing file, please wait...
                  </Alert>
                )}
                {errors && typeof errors === "object" &&  Object.keys(errors).length > 0  && (
                  <div className="mt-2 list-errors">
                    <ErrorList errors={transformErrors(errors)} />
                  </div>
                )}
              </Col>
            </Row>
          </Card>

          <Card className="p-4 mt-4 shadow-sm">
            <h4>Upload Logs</h4>
            <Table bordered className="mt-3">
              <thead>
                <tr>
                  <th>Uploaded By</th>
                  <th>Upload Date</th>
                  <th>File Name</th>
                  <th>Total</th>
                  <th>Status</th>
                  {/* <th>Error Message</th> */}
                  <th style={{width:"200px"}}>Action</th>
                </tr>
              </thead>
              <tbody>
                {uploadLogs.map((log, index) => {
                  const fileName = log.fileName || "Unknown.xlsx"; // ป้องกัน undefined
                  const fileData = log.fileContent || ""; // ป้องกัน undefined

                  return (
                    <tr
                      key={index}
                      style={{
                        backgroundColor:
                          log.status === "Success" && log.recordCount !== 0
                            ? "#e2f3a7"
                            : "#ffa5ae",
                      }}
                      className={index === 0 ? "blinking-text-header" : ""}
                    >
                      <td>{log.uploadedBy}</td>
                      <td>
                      {moment(log.uploadDateTime).tz("Asia/Bangkok").format("DD-MM-YYYY HH:mm:ss")}
                      </td>
                      <td>{fileName}</td>
                      <td>{log.recordCount}</td>
                      <td>{log.status}</td>
                      {/* <td>{log.errorMessage || "-"}</td> */}
                      <td>
                        <div className="my-0 ms-1">
                          {log && fileData && (
                            <Button
                              className="m-2"
                              variant="success"
                              size="sm"
                              onClick={() =>
                                handleDownloadFromBytes(fileName, fileData)
                              }
                            >
                              <FaFileDownload /> Excel
                            </Button>
                          )}
                      {log?.errorMessage &&
                        Object.keys(log.errorMessage).length > 0 && (
                          <Button variant="danger" size="sm" onClick={() => handleShowErrors(log.errorMessage)}>
                            <BiSolidMessageAltError /> Errors
                          </Button>
                        )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </Card>
          <Modal show={showModal} onHide={handleCloseModal} size="xl">
            <Modal.Header closeButton>
              <Modal.Title>Error Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {selectedErrorLog ? (
                <div>
                  {Object.entries(selectedErrorLog).map(([category, errors]) => (
                    <div key={category} className="mb-3">
                      <h5 className="text-danger">{category}</h5>
                      <ul>
                        {errors.map((error, idx) => (
                          <li key={idx}>
                            <strong>Row {error.row}:</strong> {error.message}
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              ) : (
                <p>No errors found.</p>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleCloseModal}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </Container>
        <Footer />
      </div>
      {pageLoder ? (
        <div className="pageLoder">
          <div className="loader-box">
            <div className="spinner"></div>
          </div>
        </div>
      ) : (
        <></>
      )}
      <ToastContainer />
    </div>
  );
};
